import { Tooltip, Space,Button,Badge } from "antd";
// import { Image } from "antd";
// import { PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { docLinkRender } from "../../../components/table/DocLink";
// import { 
//   BACKEND_URL_MAIN
//  } from '../../../utils/util';

// import dayjs from 'dayjs';

export const accessColumn = ({ handleEdit, handleDelete, handleView }) => [
  {
    key: "id",
    dataIndex: "id",
    align: "left",
    hidden: true,
  },
  {
    title: "FG Code",
    dataIndex: "fg_code",
    key: "fg_code",
    sorter: (a, b) => (a?.fg_code || "").localeCompare(b?.fg_code || ""),
    width: 140,
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดูข้อมูลสินค้า"),
  },
  {
    title: "FG Name (TH)",
    dataIndex: "fg_name",
    key: "fg_name",
    width: "25%",
    sorter: (a, b) => (a?.fg_name || "").localeCompare(b?.fg_name || ""),
    ellipsis: { showTitle: false, },
    render: (v) => <Tooltip placement="topLeft" title={v}>{v}</Tooltip>,
  },
  {
    title: "FG Name (EN)",
    dataIndex: "fg_nameEN",
    key: "fg_nameEN",
    width: "25%",
    sorter: (a, b) => (a?.fg_nameEN || "").localeCompare(b?.fg_nameEN || ""),
    ellipsis: { showTitle: false, },
    render: (v) => <Tooltip placement="topLeft" title={v}>{v}</Tooltip>,
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    sorter: (a, b) => (a?.code || "").localeCompare(b?.code || ""),
    width: 140,
  },
  {
    title: "สถานะ",
    dataIndex: "active_status",
    key: "active_status",
    width: "10%",
    sorter: (a, b) => (a?.active_status || "").localeCompare(b?.active_status || ""),
    render: (data) => (
      <div>
        {data === "เปิดการใช้งาน" ? (
          <Badge status="success" text="เปิดการใช้งาน" />
        ) : (
          <Badge status="error" text="ปิดการใช้การ" />
        )}
      </div>
    ),
  },
  // {
  //   title: "ราคา",
  //   dataIndex: "price",
  //   key: "price",
  //   className: "!pe-4",
  //   align:'right',
  //   sorter: (a, b) => (a?.price || "").localeCompare(b?.price || ""),
  //   render:(v)=>formatMoney( Number(v || 0))
  // },
  {
    title: "Action",
    key: "operation",
    width: "100px",
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(record)}
        />
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
      </Space>
    ),
  },
];
